





































































import camelcaseKeysDeep from 'camelcase-keys-deep';
import CreateSubscription from '@/components/enterprise/subscriptions/create-subscription.vue';
import Enterprise from '@/datatypes/enterprise';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import EnterpriseSubscriptionInfo from '@/components/billing/enterprise-subscription-info.vue';

export default Vue.extend({
  components: {
    CreateSubscription,
    SnackbarMessageHandler,
    EnterpriseSubscriptionInfo,
  },
  data: () => ({
    enterprise: new Enterprise({}),
    errorMessage: '',
    enterpriseService: new EnterpriseService(),
    actionType: 'viewing',
    subscriptionTypes: [
      {
        type: 'enterprise',
        name: 'Enterprise',
      },
      {
        type: 'standard',
        name: 'Standard',
      },
    ],
  }),

  mounted() {
    this.fetchEnterprise();
  },

  methods: {
    fetchEnterprise(): void {
      if (this.$route.params.id) {
        this.enterpriseService.getEnterprise(this.$route.params.id).then((response) => {
          this.enterprise = new Enterprise(camelcaseKeysDeep(response.data));
        });
      }
    },

    emiterrorMessage(message: string): void {
      this.errorMessage = message;
    },

    requestSubscribe(): void {
      this.actionType = 'newSubscription';
    },

    chooseCustomer() {
      return '';
    },
    reloadCustomer() {
      return '';
    },
    reloadSubscription() {
      return '';
    },

    resetAction(message: string): void {
      this.actionType = 'viewing';

      if (typeof message === 'string') {
        this.emiterrorMessage(message);
      }
    },

    resetActionWithReload(message: string): void {
      this.resetAction(message);
      this.fetchEnterprise();
    },
  },

  computed: {
    enterpriseId() {
      return this.$route.params.id;
    },
    canManageCustomer() {
      return !this.enterprise.hasSubscription();
    },
    canNewCustomer() {
      return this.enterprise.canNewCustomer();
    },
    canNewSubscription() {
      if (this.enterprise.canNewCustomer()) {
        return false;
      }

      return this.enterprise.canNewSubscription();
    },
    hasSubscription() {
      return this.enterprise.hasSubscription();
    },
  },
});
